import { HttpClient } from '@angular/common/http';
import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Store } from '@ngrx/store';
import { CoalService } from 'app/services/coal.service';
import { MostrarSpinner, OcultarSpinner } from 'app/store/actions/utils.action';
import { AppState } from 'app/store/app.states';
import { environment } from 'environments/environment';

@Component({
    selector: 'app-upload-files',
    templateUrl: './upload-files.component.html',
    styleUrls: ['./upload-files.component.css']
})
export class UploadFilesComponent implements OnInit {
    @Input() idOperacion: any;
    @Input() disabled: boolean = true;
    @Input() api: string;
    @Input() dataField: string;
    @Input() title: string = '';
    @Input() files: any[];
    @Input() accept: string = '';
    @Output() uploaded = new EventEmitter<any>();

    url: string;
    buttonDisabled: boolean = true;
    alertinvalid = false;
    myFiles: File[] = []; // Cambia el tipo de string[] a File[]
    fileLoaded = false; // Estado que indica si el archivo ha sido cargado correctamente
    isDragging = false; // Estado para saber si se está arrastrando un archivo
    isInvalidFile = false;
    isSuccess = false;


    constructor(private http: HttpClient, private coalService: CoalService, private store: Store<AppState>) { }

    ngOnInit(): void {
        // this.url = environment.serviceUrl.substring(0, environment.serviceUrl.indexOf("api") - 1);
        this.url = environment.hostBack;
    }

    onDragOver(event: DragEvent) {
        event.preventDefault();
        this.isDragging = true;
        this.isInvalidFile = false;
    }

    onDragLeave(event: DragEvent) {
        event.preventDefault();
        this.isDragging = false;
    }

    onDrop(event: DragEvent) {
        event.preventDefault();
        this.isDragging = false;

        if (event.dataTransfer && event.dataTransfer.files.length > 0) {
            const files = event.dataTransfer.files;
            if (this.isFileValid(files)) {
                this.isInvalidFile = false;
                this.isSuccess = true;
                this.handleFileInput(files);
            } else {
                this.isInvalidFile = true;
                this.isSuccess = false;
                setTimeout(() => {
                    this.isInvalidFile = false;
                    this.resetAnimation();
                }, 500); // 10 segundos
            }
        }
    }

    resetAnimation() {
        const container = document.querySelector('.custom-upload-container');
        if (container) {
            container.classList.add('reset-animation');
            setTimeout(() => {
                container.classList.remove('reset-animation');
            }, 1000); // Duración de la transición para regresar al estado normal
        }
    }

    isFileValid(files: FileList): boolean {
        for (let i = 0; i < files.length; i++) {
            const file = files[i];
            if (!this.accept.split(',').some(x => file.name.includes(x))) {
                return false;
            }
        }
        return true;
    }

    onFileChange2(event: any) {
        this.handleFileInput(event.target.files);
    }

    handleFileInput(files: FileList) {
        this.alertinvalid = false;
        this.myFiles = [];
        for (let i = 0; i < files.length; i++) {
            const file = files[i];
            if (this.accept.split(',').find(x => file.name.includes(x))) {
                this.myFiles.push(file); // Aquí estás empujando un objeto File en lugar de un string
                this.fileLoaded = true; // Actualiza el estado cuando el archivo se carga correctamente
                this.submit();
                this.buttonDisabled = false;
            } else {
                this.alertinvalid = true;
                this.buttonDisabled = true;
            }
        }
    }

    submit() {
        if (this.myFiles.length != 0) {
            const formData = new FormData();
            for (var i = 0; i < this.myFiles.length; i++) {
                formData.append(`files`, this.myFiles[i]);
            }

            this.store.dispatch(MostrarSpinner());
            this.http.post(environment.hostBack + '/api/upload', formData).subscribe((file: any) => {
                this.store.dispatch(OcultarSpinner());
                if (this.api && this.dataField) {
                    let preData = `{"data": { "${this.dataField}": ${file[0].id}}}`;
                    let data = JSON.parse(preData);
                    this.coalService.putService(this.api, data).subscribe(
                        (res: any) => {
                            this.uploaded.emit();
                        }, (error: any) => {
                            // Manejar error
                        });
                } else {
                    this.uploaded.emit({ file });
                }
            }, (error: any) => {
                this.store.dispatch(OcultarSpinner());
                console.log(error);
            });
        } else {
            this.alertinvalid = true;
        }
    }
}
